<template>
  <div class="px-8 pt-8 pb-6 text-center">
    <div
      class="w-16 h-16 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg"
    >
      <GraduationCapIcon class="w-8 h-8 text-white" />
    </div>
    <h1 class="text-3xl font-bold text-gray-800 mb-2">Welcome Back</h1>
    <p class="text-gray-600 font-medium">Sign in to your school account</p>
  </div>
</template>

<script setup>
  import { GraduationCapIcon } from "lucide-vue-next";
</script>
